import { render, staticRenderFns } from "./Dashboard-mongustave-an.vue?vue&type=template&id=e5c60734&scoped=true&"
import script from "./Dashboard-mongustave-an.vue?vue&type=script&lang=js&"
export * from "./Dashboard-mongustave-an.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-mongustave-an.vue?vue&type=style&index=0&id=e5c60734&scoped=true&lang=css&"
import style1 from "./Dashboard-mongustave-an.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c60734",
  null
  
)

export default component.exports